import { ConsoleMyProfileEditQuery, Maybe } from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { ProfileEditForm, Props } from './ProfileEditForm'

export * from './fragments'

export type State = {
  artistId: string
  user: Maybe<ConsoleMyProfileEditQuery['artist']>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmitMyProfile: Props['onSubmitMyProfile']
  onClickAvatar: Props['onClickAvatar']
}

export const ConsoleMyProfileEditTemplate: Template<State, Action> = ({
  state: { user, artistId },
  onSubmitMyProfile,
  onClickAvatar,
}) => {
  const { t } = useTranslation('consoleMyProfileEdit')
  const { routerNames, routerPages } = useRouter()

  return (
    <ArtistThemeProvider artistId={artistId}>
      <ConsoleBaseLayout
        header={{
          title: t('title'),
          defaultBackPage: routerPages.ConsoleDashboard,
          back: true,
        }}
      >
        <Head title={routerNames.ConsoleMyProfileEdit} />
        <ProfileEditForm
          user={user}
          artistId={artistId}
          onSubmitMyProfile={onSubmitMyProfile}
          onClickAvatar={onClickAvatar}
        />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
